import { Controller, Toolbar } from '@tencent/workbench';
import { FontSizeIncreaseFeature } from './font-size-increase-feature';
import { TOOLBAR_ITEMS, config } from './config';
import { FORM_CONFIGS_FONT_INCREASE } from '../../drawer/ui/text/font/config';
import { Form } from '@tencent/wb-ext-form';
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    formItems: FORM_CONFIGS_FONT_INCREASE,
})
export class FontSizeIncreaseController {
    constructor(private readonly feature: FontSizeIncreaseFeature) {
    }

    @Toolbar(config.id, 'onClick')
    public onClick() {
        this.feature.onClick(true);
    }

    @Toolbar(config.id, 'shouldDisabled')
    @Form(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }

    @Form(config.id, 'onClick')
    public onDrawerClick() {
        this.feature.onClick(true, true);
    }
}
